const {
  VITE_APPINSIGHTS_CONNECTION_STRING,
  VITE_APPINSIGHTS_ENABLE_CONSOLE_LOGGING,
  VITE_API_BASE_URL,
  VITE_API_KEY,
  MODE,
} = import.meta.env;

export {
  VITE_APPINSIGHTS_CONNECTION_STRING,
  VITE_APPINSIGHTS_ENABLE_CONSOLE_LOGGING,
  VITE_API_BASE_URL,
  VITE_API_KEY,
  MODE,
};

export function getEnvVariable(key: string): string | undefined {
  return import.meta.env[key];
}
